import React, { useMemo, useCallback, useEffect, useState } from "react";
import KOTPrintThermal from "./KOTPrintThermal";
import KOTPrintIMIN from "./KOTPrintIMIN";

const KOTPrint = ({
  session,
  items = [],
  kotNumber,
  onPrintComplete,
  previewOnly,
}) => {
  const [triggerPrint, setTriggerPrint] = useState(false);
  
  const isWindows = useMemo(() => {
    if (typeof navigator === "undefined") return false;
    return navigator.platform?.indexOf("Win") > -1;
  }, []);

  const hostIsLocal = useMemo(() => {
    if (typeof window === "undefined") return false;
    try {
      const host = window.location?.hostname || "";
      return host === "localhost" || host === "127.0.0.1";
    } catch {
      return false;
    }
  }, []);

  const previewMode = previewOnly || (isWindows && hostIsLocal);

  const logKOT = useCallback(() => {
    const summary = {
      type: "KOT",
      kotNumber,
      label: session?.label,
      itemCount: items?.length || 0,
      items: (items || []).map((i) => ({ name: i.name, qty: i.qty })),
      at: new Date().toISOString(),
    };
    console.log("[KOT Sent to Kitchen]", summary);
  }, [items, kotNumber, session?.label]);

  useEffect(() => {
    if (!items?.length || !previewMode) return;

    logKOT();
    const timer = setTimeout(() => {
      onPrintComplete?.();
    }, 500);
    return () => clearTimeout(timer);
  }, [items, previewMode, logKOT, onPrintComplete]);

  // For IMIN: Wait for element to render, then trigger print (like button click)
  useEffect(() => {
    if (previewMode || isWindows || !items?.length) return;
    
    // Wait for element to be rendered and painted (like Daily Report button click)
    const timer = setTimeout(() => {
      setTriggerPrint(true);
    }, 300); // Element is rendered, now trigger print
    
    return () => clearTimeout(timer);
  }, [items, kotNumber, previewMode, isWindows]);

  if (!items?.length) return null;

  if (previewMode) {
    return null;
  }

  const sharedProps = {
    session,
    items,
    kotNumber,
    onPrintComplete,
    onLog: logKOT,
  };

  if (isWindows) {
    return <KOTPrintThermal {...sharedProps} />;
  }

  return <KOTPrintIMIN {...sharedProps} triggerPrint={triggerPrint} />;
};

export default KOTPrint;
